import classes from "../styles/RootLayout.module.css";
import HeaderFooterNav from "./HeaderFooterNav";
import gmail from "../assets/images/gmail.png";
import insta from "../assets/images/instagram.png";
import linkedin from "../assets/images/linkedin.png";
import phone from "../assets/images/telephone.png";
import github from "../assets/images/github.png";

//import { NavLink } from "react-router-dom";

export default function Footer() {
  return (
    <>
      <div className={classes["footer-header"]}>
        <h2>RAJALAKSHMI SUDHAKAR</h2>
        <div className={classes["footer-links"]}>
          <HeaderFooterNav />
        </div>
      </div>

      <div className={classes["footer-separator"]}></div>

      <div className={classes["footer-header"]}>
        <div className={classes["footer-copyright"]}>
          RA$HMI © 2024. All Rights Reserved.
        </div>
        <div className={classes["footer-social"]}>
          <a
            href="mailto:srajalakshmi62@gmail.com"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={gmail} alt="GmailLogo" />
          </a>
          <a
            href="https://www.linkedin.com/in/rajalakshmi-sudhakar"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={linkedin} alt="LinkedinLogo" />
          </a>
          <a href="tel:+16177087960" target="_blank" rel="noopener noreferrer">
            <img src={phone} alt="PhoneLogo" />
          </a>
          <a
            href="https://github.com/Rajalakshmi-Sudhakar/ReactJS_Projets/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={github} alt="GitHubLogo" />
          </a>
          <a
            href="https://www.instagram.com/rashmi_artz?igsh=aTVoeGF4YTRtc2c1"
            target="_blank"
            rel="noopener noreferrer"
          >
            <img src={insta} alt="InstagramLogo" />
          </a>
        </div>
      </div>
    </>
  );
}
